import { createTranslate } from 'core/translate';

const translate = createTranslate(() => window.appLabels);

export { translate };
